export const USER = 'loomSSRUser';
export const VIDEO = 'loomSSRVideo';
export const SCREENSHOT = 'loomSSRScreenshot';
